import { NotificationsHeaderRow } from "./TableParts/_HeaderRow";
import { NotificationsRows } from "./TableParts/_NotificationsRows";
import { NotificationsUnitRow } from "./TableParts/_NotificationsUnitRow";

export const TableParts = {
  HeaderRow: NotificationsHeaderRow,
  Rows: NotificationsRows,
  Row: NotificationsUnitRow,
};
